import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { solutionCatalog } from '../../data/solutions/catalog';
import type { CustomerStory } from '../../types/story';
export function FeaturedStory({
  story
}: {
  story: CustomerStory;
}) {
  const industry = solutionCatalog[story.industry]?.title;
  return <article aria-labelledby="featured-story-title" className="grid grid-cols-1 overflow-hidden rounded-[16px] bg-white shadow-[0_24px_48px_-32px_rgba(11,11,11,0.28)] lg:grid-cols-[minmax(0,1.25fr)_minmax(0,1fr)]" data-id="element-1607" data-mp="1cpm3wyl2waca">
      <img src={story.image} alt={story.alt} className="h-[300px] w-full object-cover sm:h-[400px] lg:h-full lg:min-h-[460px]" data-id="element-1608" data-mp="1rd77etlv8bkq" />
      <div className="flex flex-col p-7 sm:p-10" data-id="element-1609" data-mp="1wcjt3b103clq">
        <div className="flex flex-wrap items-center gap-2" data-id="element-1610" data-mp="1we370uz6pbkc">
          <span className="text-[13px] font-semibold text-brand" data-id="element-1611" data-mp="20f6lpe5hx1jz">Featured story</span>
          {industry && <span className="rounded-full bg-canvas-warm px-2.5 py-1 text-[12px] font-medium text-ink" data-id="element-1612" data-mp="25dhtzkg57403">{industry}</span>}
        </div>
        <h2 id="featured-story-title" className="mt-4 text-[22px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1613" data-mp="1rp4l0dfe7nbg">
          {story.business}
        </h2>
        <blockquote className="display mt-5 text-[24px] font-semibold text-ink sm:text-[28px]" data-id="element-1614" data-mp="1mqbi1exqfepj">“{story.quote}”</blockquote>
        <p className="mt-4 text-[14px] text-ink-muted" data-id="element-1615" data-mp="1hst9hpnmn1i2">
          <span className="font-semibold text-ink" data-id="element-1616" data-mp="2fdfhl4e230tx">{story.owner}</span>, {story.role} · {story.location}
        </p>
        <div className="mt-8 border-t border-canvas-line pt-6 lg:mt-auto" data-id="element-1617" data-mp="2afw2y3dg4m1g">
          <p className="display text-[36px] font-semibold text-brand" data-id="element-1618" data-mp="25nvvzqyyksvd">{story.results[0].value}</p>
          <p className="mt-1 text-[14px] text-ink-muted" data-id="element-1619" data-mp="20qciita34k4h">{story.results[0].label}</p>
          <SmartLink href={`/customers/${story.slug}`} className="group mt-6 inline-flex items-center gap-1.5 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-1620" data-mp="2y5gnurt5ttdd">
            Read the story
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1621" data-mp="rj2ai0pl4nbv" />
          </SmartLink>
        </div>
      </div>
    </article>;
}